module.exports = __webpack_public_path__ + "img/order-step8-c.242fa68d.png";